import { Component, OnInit } from '@angular/core';
import { ContentService } from '../../shared/content.service';

@Component({
  selector: 'app-lovely',
  templateUrl: './lovely.component.html',
  styleUrls: ['./lovely.component.scss']
})
export class LovelyComponent implements OnInit {
  page: Object;

  constructor(private contentService: ContentService) {
  }

  ngOnInit() {
    this.page = this.contentService.pages['lovely'];
  }

}
